const DevelopmentOrderType = {
  GET_ORDER_MEASUREMENTS: 'GET_ORDER_MEASUREMENTS',
  SET_ORDER_MEASUREMENTS: 'SET_ORDER_MEASUREMENTS',
  GET_ORDER_DESIGN_DETAIL: 'GET_ORDER_DESIGN_DETAIL',
  GET_SINGLE_DESIGN_DETAIL: 'GET_SINGLE_DESIGN_DETAIL',
  GET_ORDER_SAMPLES: 'GET_ORDER_SAMPLES',
  GET_ORDER_TESTING: 'GET_ORDER_TESTING',
  GET_TESTING_BOM_LIST: 'GET_TESTING_BOM_LIST',
  GET_TESTING_COLOUR_LIST: 'GET_TESTING_COLOUR_LIST',
  GET_ALL_LIBRARY_LIST: 'GET_ALL_LIBRARY_LIST',
  GET_ALL_GROUP_LIST: 'GET_ALL_GROUP_LIST',
  GET_ALL_PRODUCTS: 'GET_ALL_PRODUCTS',
  GET_ALL_PRODUCT_LIST: 'GET_ALL_PRODUCT_LIST',
  GET_THE_COMMENTS: 'GET_THE_COMMENTS',
  GET_ALL_REPORTS: 'GET_ALL_REPORTS',
  GET_ALL_ARCHIVE_REPORTS: 'GET_ALL_ARCHIVE_REPORTS',
  DATA_FOR_PREVIEW: 'DATA_FOR_PREVIEW',
  GET_MAIN_SAMPLES: 'GET_MAIN_SAMPLES',
  GET_SUPPLIER: 'GET_SUPPLIER',
  SAMPLE_LENGTH: 'SAMPLE_LENGTH',
  SAMPLE_COLOUR_WAY: 'SAMPLE_COLOUR_WAY',
  SAMPLE_SIZE: 'SAMPLE_SIZE',
  TESTING_ATTRIBUTES: 'TESTING_ATTRIBUTES',
  TESTING_REQUIRMENTS: 'TESTING_REQUIRMENTS',
  GET_ALL_PRODUCT_REF: 'GET_ALL_PRODUCT_REF',
  CLEAR_REDUCER: 'CLEAR_REDUCER',
  GET_ALL_PRODUCT_REF_BOM: 'GET_ALL_PRODUCT_REF_BOM',
  SAMPLE_PERMISSION: 'SAMPLE_PERMISSION',
  SAMPLE_ANNOTATIONS_IMAGE: 'SAMPLE_ANNOTATIONS_IMAGE',
  SAMPLE_IMAGE: 'SAMPLE_IMAGE',
  UPDATE_SAMPLE_SWITCHES: 'UPDATE_SAMPLE_SWITCHES',
  UPDATE_NEW_ORDER_TESTING: 'UPDATE_NEW_ORDER_TESTING',
  UPDATE_NEW_PRODUCT_BOM: 'UPDATE_NEW_PRODUCT_BOM',
  SAMPLE_DETAILS: 'SAMPLE_DETAILS',
  MISSING_COMPONENT: 'MISSING_COMPONENT',
  SEARCH_TEXT: 'SEARCH_TEXT',
  SELECTED_IDS_ARRAY: 'SELECTED_IDS_ARRAY',
  GET_SAMPLE_STATUS: 'GET_SAMPLE_STATUS',
  SAMPLE_TRAKING_ARRAY: 'SAMPLE_TRAKING_ARRAY',
  SAMPLE_TRACKING_DATES_DATA: 'SAMPLE_TRACKING_DATES_DATA',
  DEVELOPMENT_ORDER_UNMOUNT: 'DEVELOPMENT_ORDER_UNMOUNT',
  UNMOUNT_SAMPLE_DETAIL: 'UNMOUNT_SAMPLE_DETAIL',
  GET_SAMPLE_SPECIFICATION: 'GET_SAMPLE_SPECIFICATION',
  GET_SAMPLE_SPECIFICATION_SIZE: 'GET_SAMPLE_SPECIFICATION_SIZE',
  COUNT_UNREAD_COMMENTS: 'COUNT_UNREAD_COMMENTS',
  FILTERED_TESTING_REPORTS: 'FILTERED_TESTING_REPORTS',
  UNMOUNT_SAMPLE_SPECIFICATION_SIZE: 'UNMOUNT_SAMPLE_SPECIFICATION_SIZE',
  ALL_DOCUMENT_OPTION_LIST: 'ALL_DOCUMENT_OPTION_LIST',
  RESET_MODAL: 'RESET_MODAL',
  ALL_DESIGN_DETAILS: 'ALL_DESIGN_DETAILS',
  UPDATE_DESIGN_PDF_EXCLUDED_COMMENT: 'UPDATE_DESIGN_PDF_EXCLUDED_COMMENT',
  DESIGN_DETAILS_PERMISSION: 'DESIGN_DETAILS_PERMISSION',
  SAMPLE_SPECIFICATION: 'SAMPLE_SPECIFICATION',
  MEASUREMENT_PRODUCT: 'MEASUREMENT_PRODUCT',
  PRODUCT_GRADING: 'PRODUCT_GRADING',
  PRODUCT_GRADING_MEASUREMENTS: 'PRODUCT_GRADING_MEASUREMENTS',
  SPEC_SEARCH: 'SPEC_SEARCH',
  MEASUREMENT_DATA: 'MEASUREMENT_DATA',
  MEASUREMENT_HIDDEN_SIZES_BY_GROUP: 'MEASUREMENT_HIDDEN_SIZES_BY_GROUP',
  CAD_DATA: 'CAD_DATA',
  CAD_SPEC_DATA: 'CAD_SPEC_DATA',
  CLEAR_CAD_SEARCH: 'CLEAR_CAD_SEARCH',
  UNITS: 'UNITS',
  MAEK_AS_COMPLETE: 'MAEK_AS_COMPLETE',
  REPLACE_SAMPLE_IMAGE: 'REPLACE_SAMPLE_IMAGE',
  DEVORDER_PRODUCT_LIST: 'DEVORDER_PRODUCT_LIST',
  DEVORDER_PRODUCT_LIST_PATCH: 'DEVORDER_PRODUCT_LIST_PATCH',
  PRODUCT_EDIT_DATA: 'PRODUCT_EDIT_DATA',
  PRODUCT_EDIT_RULE: 'PRODUCT_EDIT_RULE',
  ADMIN_USER: 'ADMIN_USER',
  COMPANY_USER: 'COMPANY_USER',
  REORDER_PRODUCT_DATA: 'REORDER_PRODUCT_DATA',
  REORDER_LIST: 'REORDER_LIST',
  UNMOUNT_LIST: 'UNMOUNT_LIST',
  UNMOUNT_PRODUCT_MODAL: 'UNMOUNT_PRODUCT_MODAL',
  UNMOUNT_DESIGN_DETAILS: 'UNMOUNT_DESIGN_DETAILS',
  GET_ALL_OPEN_PRODUCTS: 'GET_ALL_OPEN_PRODUCTS',
  CLEAR_PRODUCT_GRADING: 'CLEAR_PRODUCT_GRADING',
  CLEAR_CAD_SPEC: 'CLEAR_CAD_SPEC',
  GET_SAMPLES: 'GET_SAMPLES',
  GET_SAMPLE_TYPE_GROUPS_BY_PRODUCT: 'GET_SAMPLE_TYPE_GROUPS_BY_PRODUCT',
  CLEAR_SAMPLE_TYPE_GROUPS_BY_PRODUCT: 'CLEAR_SAMPLE_TYPE_GROUPS_BY_PRODUCT',
  CLEAR_SPECIFICATION_REDUCER: 'CLEAR_SPECIFICATION_REDUCER',
  PRODUCT_LIST_DEVORDER: 'PRODUCT_LIST_DEVORDER',
  CUSTOM_MODULE_MENU: 'CUSTOM_MODULE_MENU',
  GET_PRODUCT_CM_BY_ID: 'GET_PRODUCT_CM_BY_ID',
  CLEAR_CUSTOM_LIB_DATA: 'CLEAR_CUSTOM_LIB_DATA',
  CUSTOM_MODULE_PERMISSION_DATA: 'CUSTOM_MODULE_PERMISSION_DATA',
  GET_DESIGN_SUPPORTING_DOC: 'GET_DESIGN_SUPPORTING_DOC',
  CLEAR_MEASUREMENT_GRADING_DATA: 'CLEAR_MEASUREMENT_GRADING_DATA',
  PRODUCT_LIST_MATCH: 'PRODUCT_LIST_MATCH',
  CLEAR_PRODUCT_LIST_MATCH: 'CLEAR_PRODUCT_LIST_MATCH',
  GET_MULTI_SUBMIT_LIST: 'GET_MULTI_SUBMIT_LIST',
  GET_PRODUCT_IDENTIFIER_LIST: 'GET_PRODUCT_IDENTIFIER_LIST',
  CLEAR_IDENTIFIER_REDUCER: 'CLEAR_IDENTIFIER_REDUCER',
  PRODUCST_PAGES: 'PRODUCST_PAGES',
  CUSTOM_MODULE_MENU_LOADING_STATE: 'CUSTOM_MODULE_MENU_LOADING_STATE',
  GET_PRODUCT_CM_PAGES: 'GET_PRODUCT_CM_PAGES',
  GET_PRODUCT_CM_DEPENDENT_LISTS: 'GET_PRODUCT_CM_DEPENDENT_LISTS',
  SET_PRODUCT_NAME: 'SET_PRODUCT_NAME',
  DPP_MODULE_MENU: 'DPP_MODULE_MENU',
  GET_ALL_COUNT_OPTIONS: 'GET_ALL_COUNT_OPTIONS',
  GET_BOM_DETAILS_BY_ID: 'GET_BOM_DETAILS_BY_ID',
  CLEAR_BOM_EDIT_ADD: 'CLEAR_BOM_EDIT_ADD',
  FETCH_TYPE_BASED_CATEGORY: 'FETCH_TYPE_BASED_CATEGORY',
  SYSTEM_CANVAS_MODULE_MENU: 'SYSTEM_CANVAS_MODULE_MENU',
  LIBRARY_CARD_MENU: 'LIBRARY_CARD_MENU',
  SPEC_POM_ALL_CODES: 'SPEC_POM_ALL_CODES',
};

export default DevelopmentOrderType;
